import { customAlphabet } from "nanoid";
import { ulid } from "ulid";

/**
 * Preferred nanoid of the codebase. 12 characters long, simplified character selection.
 * Do not import nanoid directly in the codebase. Always import @repo/utils/nanoid in consuming packages/apps.
 */
const NANOID_CHARS = "0123456789abcdefghijklmnopqrstuvwxyz"; // NOTE(johnrjj) - All lowercase
const nanoidLegacy = customAlphabet(NANOID_CHARS, 8);
const nanoidPortfolioId = customAlphabet(NANOID_CHARS, 8);
const nanoidInviteCode = customAlphabet(NANOID_CHARS, 8);

// Public receipt-share slugs: the slug is the entire secret for
// anyone-with-the-link access, so it uses the full mixed-case alphanumeric
// alphabet at 24 chars (~143 bits).
const RECEIPT_SHARE_SLUG_CHARS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const nanoidReceiptShareSlug = customAlphabet(RECEIPT_SHARE_SLUG_CHARS, 24);

const nanoid = ulid;
const uuid = ulid;

export {
  nanoid,
  uuid,
  nanoidInviteCode,
  nanoidLegacy,
  nanoidPortfolioId,
  nanoidReceiptShareSlug,
};
